export const ZILLOUT_WEB_BASE_URL =
  "https://zillout.com";
